import axios from "axios";

import ticketOptions from "consts/ticketOptions"

const getOrderData = (data) => JSON.stringify({
    items: [{
        id: "CyberSecGO-ticket",
        title: "Ingresso CyberSecGO",
        category_id: "ingressos",
        quantity: 1,
        currency_id: "BRL",
        unit_price: ticketOptions.price
    }],
    "payer": {
        "phone": {
            "number": data.telefone
        },
        "email": data.email
    },
    "payment_methods": {
        "excluded_payment_methods": [],
        "excluded_payment_types": [
            {
                "id": "ticket"
            }
        ]
    },
    "back_urls": {},
    "external_reference": data.ticketId,
    "statement_descriptor": "CyberSecGO",
    "binary_mode": true
});

export async function createPreference(data) {
    return axios.request({
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://api.mercadopago.com/checkout/preferences',
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_MERCADO_PAGO_ACCESS}`,
            'Content-Type': 'application/json'
        },
        data: getOrderData(data)
    });
}